import React, { useState } from "react";
import client, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ShieldAlert, Loader2 } from "lucide-react";

const ForcePasswordChange: React.FC = () => {
  const { clearPasswordExpired, logout } = useAuth();
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await client.post("/auth/change-password", { current_password: cur, new_password: next });
      toast.success("Contraseña actualizada. Ya puedes continuar.");
      clearPasswordExpired();
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-900 p-4" data-testid="force-password-change">
      <div className="w-full max-w-md border border-slate-700 bg-white p-8">
        <div className="mb-5 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-sm bg-[#DD0000]">
            <ShieldAlert className="h-6 w-6 text-white" strokeWidth={1.5} />
          </div>
          <div>
            <h1 className="text-lg font-semibold text-slate-800">Contraseña vencida</h1>
            <p className="text-xs text-slate-400">Por seguridad (política de 365 días) debes crear una nueva.</p>
          </div>
        </div>
        <p className="mb-4 text-xs text-slate-500">
          Mínimo 12 caracteres, con mayúsculas, minúsculas, números y un símbolo. No podrás acceder al panel ni a los
          datos de Amazon hasta actualizarla.
        </p>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <Label className="text-xs text-slate-500">Contraseña actual</Label>
            <Input type="password" value={cur} onChange={(e) => setCur(e.target.value)}
              data-testid="force-pw-current" className="mt-1.5 rounded-none border-slate-300" required />
          </div>
          <div>
            <Label className="text-xs text-slate-500">Nueva contraseña</Label>
            <Input type="password" value={next} onChange={(e) => setNext(e.target.value)}
              data-testid="force-pw-new" className="mt-1.5 rounded-none border-slate-300" required />
          </div>
          <button type="submit" disabled={loading} data-testid="force-pw-submit"
            className="flex w-full items-center justify-center gap-2 rounded-none bg-[#DD0000] py-2.5 text-sm font-medium text-white transition-colors hover:bg-[#B00000] disabled:opacity-60">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            Actualizar y continuar
          </button>
        </form>
        <button onClick={logout} className="mt-4 w-full text-center text-xs text-slate-400 hover:text-slate-600">
          Cerrar sesión
        </button>
      </div>
    </div>
  );
};

export default ForcePasswordChange;
